import { FC } from 'react';
import { PriceType, usePriceLabel } from '@edikk-edikk/country-frontend';
import { InfoCell } from '@edikk-edikk/country-layout-black';

type PropsType = {
  type: PriceType;
  value: string;
};

const Price: FC<PropsType> = ({
  type,
  value,
}) => {
  const label = usePriceLabel(type);

  return <InfoCell label={label} value={value} />;
};

export { Price };
